<template>
  <div>
    <!-- <Header /> -->

    <div class="flex">
      <SideBar />

      <div
        class="w-[90%] mx-auto lg:w-full lg:mr-10 mt-10 rounded-3xl heightfix"
        style="box-shadow: 0px 2px 30px 0px #01b0f926"
      >
        <!-- desktop -->
        <div class="hidden lg:block h-full">
          <div class="flex h-full w-full">
            <div
              class="flex flex-col gap-4 lg:w-[50%] 2xl:w-[25%] overflow-y-auto"
            >
              <div class="pt-6 pb-2">
                <p class="text-primary text-center font-bold">Messages</p>
              </div>
              <div
                v-if="loading"
                class="flex items-center justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <img src="@/assets/newd/loading.gif" alt="" />
              </div>
              <div
                v-else-if="studentList.length > 0 && !loading"
                class="overflow-y-auto rounded-b-3xl lg:rounded-b-none"
              >
                <div
                  v-for="(student, index) in this.studentList"
                  :key="student"
                  class=""
                >
                  <div
                    v-if="student.display_name"
                    @click="messageInfo(student)"
                    :class="{
                      'bg-gray-200':
                        selectedStudent.display_name == student.display_name,
                      'bg-white':
                        selectedStudent.display_name != student.display_name,
                    }"
                    class="py-2 px-3 2xl:px-10 text-base lg:text-sm mb-0  hover:bg-gray-200 cursor-pointer flex justify-between items-center"
                  >
                    <div class="flex gap-1 items-center">
                      <div
                        class="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold"
                      >
                        <div v-if="student.user_profile">
                          <img
                            :src="student.user_profile"
                            alt=""
                            class="w-10 h-10 rounded-full border-2 border-white"
                          />
                        </div>
                        <div v-else>
                          <img
                            src="@/assets/new/image.png"
                            alt=""
                            class="w-9 h-9 rounded-full border-2 border-white"
                          />
                        </div>
                      </div>
                      <div class="px-2 capitalize flex flex-col gap-1">
                        <h1 class="">{{ student.display_name }}</h1>
                        <p
                          class="text-xs font-normal text-gray-500 line-clamp-1"
                        >
                          message
                        </p>
                      </div>
                    </div>
                    <div
                      class="flex flex-col text-xs gap-1"
                      v-if="shouldShowDateLabel(index)"
                    >
                      <p>
                        {{ formatDateLabel(student.latest_received_message.created_at) }}
                      </p>
                      <div
                        v-if="student.message_count"
                        :class="
                          student.message_count < 10
                            ? 'text-[12px]'
                            : 'text-[9px]'
                        "
                        class="p-1 w-5 h-5 mx-auto text-xs rounded-full border text-[#0085db] font-semibold flex justify-center items-center bg-gray-100"
                      >
                        {{ student.message_count }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="flex flex-col justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <p class="flex justify-center">No Data Found</p>
              </div>
            </div>

            <div
              v-if="ChatpopUp"
              class="bg-[#F0F5F9] h-full w-full rounded-3xl relative lg:w-[70%] 2xl:w-[75%]"
            >
              <div class="absolute w-full left-0 right-0">
                <div class="bg-[#FFFFFF] rounded-2xl m-4 py-2 px-3">
                  <p class="text-center text-primary font-semibold">
                    {{ this.selectedStudent.display_name }}
                  </p>
                </div>
              </div>

              <div class="h-full w-full px-3 pt-14 pb-16">
                <div class="p-4 h-full overflow-y-auto" id="chatContainer">
                  <div
                    v-for="message in totalmessage"
                    :key="message"
                    class="my-4 flex flex-col gap-1"
                  >
                    <p class="text-lg font-bold text-gray-700">
                      {{ message[3] }}
                    </p>
                    <span class="text-xs text-gray-600">{{ message[1] }}</span>
                    <p class="text-sm">{{ message[0] }}</p>
                  </div>
                </div>
              </div>

              <div class="absolute bottom-2 w-full left-0 right-0">
                <div
                  class="bg-[#FFFFFF] rounded-2xl m-4 flex items-center justify-between py-2 px-3 gap-10"
                >
                  <input
                    type="text"
                    class="w-[95%] border-none outline-none text-primary"
                    placeholder="Type your text here..."
                    @keyup.enter="sendmsg(this.selectedStudent)"
                    v-model="messageVal"
                    name=""
                    id=""
                  />
                  <button
                    @click="sendmsg(this.selectedStudent)"
                    class="bg-blues w-[30px] h-[30px] rounded-full flex items-center justify-center"
                  >
                    <img src="@/assets/newd/arrow.png" alt="" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- mobile -->
        <div class="block lg:hidden h-full">
          <div class="flex h-full">
            <div
              v-if="studentmessage"
              class="flex flex-col gap-4 w-full overflow-y-auto"
            >
              <div class="pt-6 pb-2">
                <p class="text-primary text-center font-bold">Messages</p>
              </div>
              <div
                v-if="loading"
                class="flex items-center justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <img src="@/assets/newd/loading.gif" alt="" />
              </div>
              <div
                v-else-if="studentList.length > 0 && !loading"
                class="overflow-y-auto rounded-b-3xl"
              >
                <div
                  v-for="(student,index) in this.studentList"
                  :key="student"
                  class=""
                >
                  <div
                    v-if="student.display_name"
                    @click="messageInfo(student)"
                    class="py-3 px-5 text-base lg:text-sm bg-white mb-0 hover:bg-gray-200 cursor-pointer flex justify-between items-center"
                  >
                    <div class="flex gap-1 items-center">
                      <div
                        class="w-9 h-9 rounded-full flex items-center justify-center text-white font-bold"
                      >
                        <div v-if="student.user_profile">
                          <img
                            :src="student.user_profile"
                            alt=""
                            class="w-10 h-10 rounded-full border-2 border-white"
                          />
                        </div>
                        <div v-else>
                          <img
                            src="@/assets/new/image.png"
                            alt=""
                            class="w-9 h-9 rounded-full border-2 border-white"
                          />
                        </div>
                      </div>
                      <div class="px-2 capitalize flex flex-col gap-1">
                        <h1 class="">{{ student.display_name }}</h1>
                        <p
                          class="text-xs font-normal text-gray-500 line-clamp-1"
                        >
                          message
                        </p>
                      </div>
                    </div>
                    <div
                      class="flex flex-col text-xs gap-1"
                      v-if="shouldShowDateLabel(index)"
                    >
                      <p>
                        {{ formatDateLabel(student.latest_message_updated_at) }}
                      </p>
                      <div
                        v-if="student.message_count"
                        :class="
                          student.message_count < 10
                            ? 'text-[12px]'
                            : 'text-[9px]'
                        "
                        class="p-1 w-5 h-5 mx-auto text-xs rounded-full border text-[#0085db] font-semibold flex justify-center items-center bg-gray-100"
                      >
                        {{ student.message_count }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                v-else
                class="flex flex-col justify-center"
                style="height: calc(100vh - 350px) !important"
              >
                <p class="flex justify-center">No Data Found</p>
              </div>
            </div>

            <div
              v-if="ChatpopUp"
              class="bg-[#F0F5F9] h-full w-full rounded-3xl relative"
            >
              <div
                class="flex justify-end p-2"
                @click="
                  ChatpopUp = false;
                  studentmessage = true;
                "
              >
                <p
                  class="text-textblues rounded-lg text-sm font-semibold underline cursor-pointer"
                >
                  Back
                </p>
              </div>
              <div class="absolute w-full left-0 right-0">
                <div class="bg-[#FFFFFF] rounded-2xl m-4 py-2 px-3">
                  <p class="text-center text-primary font-semibold">
                    {{ this.selectedStudent.display_name }}
                  </p>
                </div>
              </div>

              <div class="h-full w-full px-3 pt-14 pb-16">
                <div class="p-4 h-full overflow-y-auto" id="chatContainer">
                  <div
                    v-for="message in totalmessage"
                    :key="message"
                    class="my-4 flex flex-col gap-1"
                  >
                    <p class="text-lg font-bold text-gray-700">
                      {{ message[3] }}
                    </p>
                    <span class="text-xs text-gray-600">{{ message[1] }}</span>
                    <p class="text-sm">{{ message[0] }}</p>
                  </div>
                </div>
              </div>

              <div class="absolute bottom-2 w-full left-0 right-0">
                <div
                  class="bg-[#FFFFFF] rounded-2xl m-4 flex items-center justify-between py-2 px-3 gap-10"
                >
                  <input
                    type="text"
                    class="w-[95%] border-none outline-none text-primary"
                    placeholder="Type your text here..."
                    @keyup.enter="sendmsg(this.selectedStudent)"
                    v-model="messageVal"
                    name=""
                    id=""
                  />
                  <button
                    @click="sendmsg(this.selectedStudent)"
                    class="bg-blues w-[30px] h-[30px] rounded-full flex items-center justify-center"
                  >
                    <img src="@/assets/newd/arrow.png" alt="" />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- <h1>Hello Message</h1> -->
        <!-- <table class="table-auto w-full">
          <thead>
            <tr>
              <th class="p-4 border-b text-center border-r">
                S NO
              </th>
              <th class="p-4 border-b text-center border-r">
                Name
              </th>
              <th class="p-4 border-b text-center border-r">
                Email
              </th>
              <th class="p-4 border-b text-center border-r">
                Last login
              </th>
              <th class="p-4 border-b text-center">Mail to</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="i in (0, 100)" :key="i">
              <td class="p-4 border-b text-center border-r">1</td>
              <td class="p-4 border-b text-center border-r">
                Malcolm Lockyer
              </td>
              <td class="p-4 border-b text-center border-r">
                1961
              </td>
              <th class="p-4 border-b text-center border-r">
                Last login
              </th>
              <th class="p-4 border-b text-center">Mail to</th>
            </tr>
          </tbody>
        </table> -->
      </div>
    </div>
  </div>
</template>

<script>
import Header from "@/components/Instructor/Header.vue";
import SideBar from "@/components/Instructor/SideBar.vue";

import axios from "axios";
import { mapGetters } from "vuex";

export default {
  components: {
    Header,
    SideBar,
  },
  data() {
    return {
      messageVal: null,
      totalmessage: null,
      studentList: "",
      selectedStudent: null,
      ChatpopUp: false,
      instructorChat: [
        {
          id: "",
          display_name: "",
        },
      ],
      loading: true,
      studentmessage: true,
      message_list: null,
      first_time: false,
      update_message_post: false,
    };
  },

  async created() {
    await this.getstudentdetails();
    this.first_time = true;
  },

  props: ["course_id"],

  computed: {
    ...mapGetters(["userInfo"]),
  },

  mounted() {
    setTimeout(() => {
      let chatContainer = document.getElementById("chatContainer");

      if (chatContainer) {
        console.log("Height::::=", chatContainer.offsetHeight);
        chatContainer.scrollTo({
          top: chatContainer.scrollHeight + 300,
          behavior: "smooth",
        });
      }
    }, 200);
  },

  methods: {
    formatDateLabel(isoString) {
      const date = new Date(isoString);
      const now = new Date();

      const isToday = date.toDateString() === now.toDateString();

      const yesterday = new Date();
      yesterday.setDate(now.getDate() - 1);
      const isYesterday = date.toDateString() === yesterday.toDateString();

      if (isToday) {
        // Show only time like "10:45 AM"
        return date.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          hour12: true,
        });
      }

      if (isYesterday) return "Yesterday";

      const day = String(date.getDate()).padStart(2, "0");
      const month = String(date.getMonth() + 1).padStart(2, "0");
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    },

    shouldShowDateLabel(index) {
      if (index === 0) return true;

      const current = this.formatDateLabel(
        this.studentList[index].latest_message_updated_at
      );
      const previous = this.formatDateLabel(
        this.studentList[index - 1].latest_message_updated_at
      );

      return current !== previous;
    },
    scrollToBottomChat() {
      setTimeout(() => {
        console.log("Height::::=", chatContainer.offsetHeight);

        chatContainer.scrollTo({
          top: chatContainer.scrollHeight + 300,
          behavior: "smooth",
        });
      }, 200);
    },

    async getstudentdetails() {
      await axios
        .get(
          `${process.env.VUE_APP_API}/all_list/${this.course_id}/?Key=${this.userInfo.token_key}`
        )
        .then((response) => {
          // response.data["data"] = [
          //   ...new Map(
          //     response.data.data.map((i) => i[0]).map((m) => [m.id, m])
          //   ).values(),
          // ].map((i) => [i]);
          this.studentList = response.data.data;
          if (this.first_time == false) {
            this.messageInfo(response.data.data[0]);
          }

          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },

    // async getstudentdetails() {
    //   await axios
    //     .get(
    //       `${process.env.VUE_APP_API}/all_list/${this.course_id}/?Key=${this.userInfo.token_key}`
    //     )
    //     .then((response) => {
    //       response.data["data"] = [
    //         ...new Map(
    //           response.data.data.map((i) => i[0]).map((m) => [m.id, m])
    //         ).values(),
    //       ].map((i) => [i]);
    //       this.studentList = response.data;
    //     });
    // },

    async messageInfo(data) {
      if (data) {
        this.selectedStudent = data;
        this.ChatpopUp = true;
        this.studentmessage = false;
        await axios
          .get(
            `${process.env.VUE_APP_API}/one_to_one_messages/${this.userInfo.user.id}/${this.selectedStudent.id}/?Key=${this.userInfo.token_key}`
          )
          .then((Response) => {
            this.totalmessage = Response.data.data.reverse();
            this.message_list = Response.data.id_list;
          });

        this.scrollToBottomChat();
        if (this.update_message_post == false) {
          this.updateMessage();
        }

        this.update_message_post = false;
        // $(".chatArea").animate(
        //   {
        //     scrollTop: $(".chatArea")[0].scrollHeight,
        //   },
        //   1000
        // );
      }
    },

    async sendmsg(data) {
      this.update_message_post = true;
      let messagesPass = {
        text: this.messageVal,
        owner: this.userInfo.user.id,
        client: data.id,
        course_id: this.course_id,
      };

      await axios
        .post(
          `${process.env.VUE_APP_API}/talk/?Key=${this.userInfo.token_key}`,
          messagesPass
        )
        .then((Response) => {
          Response;
        });

      this.messageInfo(this.selectedStudent);
      this.scrollToBottomChat();
      setTimeout(() => {
        this.messageVal = null;
      }, 1000);
    },
    updateMessage() {
      const msg_id = {
        message_ids: this.message_list,
      };
      axios
        .post(
          `${process.env.VUE_APP_API}/message_read_status_update/?Key=${this.userInfo.token_key}`,
          msg_id
        )
        .then((resp) => {
          if (resp.data.status == 200) {
            this.getstudentdetails();
          }
          console.log("Response", Response);
        });
    },
  },
};
</script>

<style scoped>
.heightfix {
  height: calc(100vh - 170px) !important;
}
</style>
